

/**
 * 一个元素从某一个位置抛物线运动到另一个位置
 * @param {*} element 起始元素位置
 * @param {*} target 结束元素位置
 */
export default function Parabola(element, target){
  /**
 * 定义当前移动的elem的点坐标为（1，1）
 * (0,0)的话会计算不出曲率
 */
  let startX = 1;
  let startY = 1;

  /**
     * 计算出 目标点相对移动点的坐标
     * 从右上上往左下抛的时候  x 为负值，y 为正
     * 记得 网页坐标轴是 以左上为（0，0），x轴向右为正，y轴向下为正
     */
  let startele = getRect(element);
  let endele = getRect(target);
  let endX = endele.left + 20 - startele.left;
  let endY = endele.top - startele.top;

  //创建动画dom点，确定初始位置
  var movingDom = document.createElement('div');
  movingDom.style.left = startele.left + 'px';
  movingDom.style.top = startele.top + 'px';
  movingDom.className= 'moving icon icon-add-bold';
  document.body.appendChild(movingDom);

  /**
     * 公式： y = a*x*x + b*x + c
     * 假设中点(0, 0)，也就是方程中的c为0，
     * a为曲率
     */
  let c = 0; // 都没用到这个变量 - 用到的因为是0 我没加上去
  let a = ( endY / endX - startY / startX) /( endX - startX),
    b = endY / endX - a * endX;

    /**
     * 定义移动的dom的x, y
     * ax2 + by 为 y轴每次需要移动距离
     */
  let x = startX, y = startY, ax2 = 0, bx = 0;
  let timer = setInterval(function (){
    if(x > endX) {
      x = x - 6;
      ax2 = a*x*x;
      bx = b*x;
      y = ax2 + bx + c;
      movingDom.style.transform = `translate3d(${x}px,${y}px,0)`;
    } else {
      movingDom.parentNode.removeChild(movingDom);
      clearInterval(timer);
    }
  },10);

}


const clientTop = document.documentElement.clientTop;
const clientLeft = document.documentElement.clientLeft;
function getRect( elements ){
  var rect = elements.getBoundingClientRect();
  return {
    top : Math.round(rect.top - clientTop), // 距离顶部的位置
    bottom : Math.round(rect.bottom - clientTop), // 距离顶部加上元素本身的高度就等于bottom的位置
    left : Math.round(rect.left - clientLeft), // 距离左边的位置
    right : Math.round(rect.right - clientLeft) // 距离右边的位置就是 距离左边的位置加上元素本身的宽度
  };
};



// WEBPACK FOOTER //
// ./src/utils/Parabola.js